import { render, staticRenderFns } from "./top-bar-notifications-menu-item.vue?vue&type=template&id=96dc2010&"
import script from "./top-bar-notifications-menu-item.vue?vue&type=script&lang=js&"
export * from "./top-bar-notifications-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports